"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = exports.downloadFilesInEvaluation = void 0;
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var file_saver_1 = require("file-saver");
var jszip_1 = __importDefault(require("jszip"));
var lodash_1 = __importDefault(require("lodash"));
var StaffManager_1 = require("../rcm/StaffManager");
var StorageManager_1 = require("../storage/StorageManager");
var BatchPromises_1 = require("../utils/BatchPromises");
var EvaluationLoader = __importStar(require("./EvaluationLoader"));
var EvaluationExporter = __importStar(require("./ExcelExporter"));
function generateServerFile(baseFilePath, controlId, base) {
    return {
        controlId: controlId,
        name: base.name,
        path: "".concat(baseFilePath, "/").concat(controlId, "/").concat(base.name),
        url: '',
        blob: ''
    };
}
function makeFilePathsForDownload(evalType, name, dataType, controlIds) {
    return __awaiter(this, void 0, void 0, function () {
        var collectionName, templateFileExtension, result, evaluationItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    collectionName = Evaluation.getKoEvaluation(evalType);
                    templateFileExtension = evalType === Evaluation.Type.Operation ? 'xlsm' : 'xlsx';
                    result = [];
                    if (dataType === 'template' || dataType === 'both') {
                        // 템플릿만
                        lodash_1.default.forEach(controlIds, function (controlId) {
                            // 보고서 템플릿
                            var recordFileFullPath = lodash_1.default.join([
                                'Template',
                                collectionName,
                                "(".concat(collectionName, ")(").concat(controlId, ")(\uC218\uD589\uC804Template).").concat(templateFileExtension)
                            ], '/');
                            result.push({
                                controlId: controlId,
                                name: "(".concat(name, ")(").concat(controlId, ")(\uBCF4\uACE0\uC11C)\uC218\uD589\uC804Template.").concat(templateFileExtension),
                                path: recordFileFullPath,
                                url: '',
                                blob: ''
                            });
                            // 모집단 템플릿
                            result.push({
                                controlId: controlId,
                                name: "(".concat(name, ")(").concat(controlId, ")(\uBAA8\uC9D1\uB2E8)\uC218\uD589\uC804Template.xlsx"),
                                path: 'Template/(운영평가)(통제번호)(모집단)Template.xlsx',
                                url: '',
                                blob: ''
                            });
                        });
                    }
                    if (!(dataType === 'uploaded' || dataType === 'both')) return [3 /*break*/, 2];
                    return [4 /*yield*/, EvaluationLoader.getEvaluationItems(evalType, name)];
                case 1:
                    evaluationItems = _a.sent();
                    lodash_1.default.forEach(evaluationItems, function (item) {
                        if (!lodash_1.default.includes(controlIds, item.controlId)) {
                            return;
                        }
                        var controlId = item.controlId;
                        if (evalType === Evaluation.Type.Operation &&
                            item.state.state === Evaluation.ProgressState.Approved) {
                            // 2021.12.31
                            // 새로 추가된 운영평가 보고서 요약파일 위한 내용(fileName, evaluation)을 추가해주기
                            result.push({
                                controlId: controlId,
                                name: "(".concat(name, ")(").concat(controlId, ")(\uBCF4\uACE0\uC11C readonly) \uBCF4\uACE0\uC11C.xlsx"),
                                path: '',
                                url: '',
                                blob: '',
                                evaluation: item
                            });
                        }
                        var baseFilePath = "".concat(collectionName, "/").concat(name);
                        var files = item.content.files;
                        if (files.record && files.record.state === BaseFile_1.FileState.OK && files.record.checked) {
                            result.push(generateServerFile(baseFilePath, controlId, files.record));
                        }
                        if (files.population && files.population.state === BaseFile_1.FileState.OK && files.population.checked) {
                            result.push(generateServerFile(baseFilePath, controlId, files.population));
                        }
                        result.push.apply(result, lodash_1.default.compact(lodash_1.default.map(lodash_1.default.merge(files.evidence, files.extra), function (target) {
                            if (target.state === BaseFile_1.FileState.OK && target.checked) {
                                return generateServerFile(baseFilePath, controlId, target);
                            }
                            return undefined;
                        })));
                    });
                    _a.label = 2;
                case 2: return [2 /*return*/, result];
            }
        });
    });
}
function downloadFilesInEvaluation(evalType, name, treeData, dataType, controlIds) {
    return __awaiter(this, void 0, void 0, function () {
        var getControlToPath, directories, downloadFiles, staffs, preparedBlobs, zip, collectionName, zipFileName, content;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    getControlToPath = function (data, prevPath, target) {
                        lodash_1.default.forEach(data, function (node) {
                            if (node.children) {
                                getControlToPath(node.children, prevPath + '/' + node.title, target);
                                return;
                            }
                            target[node.id] = prevPath.slice(1) + '/' + node.id + '/';
                        });
                    };
                    directories = {};
                    getControlToPath(treeData, '', directories);
                    return [4 /*yield*/, makeFilePathsForDownload(evalType, name, dataType, controlIds)];
                case 1:
                    downloadFiles = _a.sent();
                    return [4 /*yield*/, (0, StaffManager_1.getAll)()];
                case 2:
                    staffs = _a.sent();
                    return [4 /*yield*/, (0, BatchPromises_1.promiseAllInBatches)(function (file) { return __awaiter(_this, void 0, void 0, function () {
                            var blob;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        blob = null;
                                        if (!(file.evaluation && file.name.includes('readonly'))) return [3 /*break*/, 2];
                                        return [4 /*yield*/, EvaluationExporter.exportToExcel(staffs, file.evaluation)];
                                    case 1:
                                        blob = _a.sent();
                                        return [3 /*break*/, 4];
                                    case 2: return [4 /*yield*/, (0, StorageManager_1.downloadBlobFromPath)(file.path)];
                                    case 3:
                                        blob = _a.sent();
                                        _a.label = 4;
                                    case 4: return [2 /*return*/, {
                                            controlId: file.controlId,
                                            zipPath: directories[file.controlId],
                                            name: file.name,
                                            blob: blob
                                        }];
                                }
                            });
                        }); }, downloadFiles, 50)];
                case 3:
                    preparedBlobs = _a.sent();
                    zip = new jszip_1.default();
                    lodash_1.default.forEach(preparedBlobs, function (preparedBlob) {
                        zip.file(preparedBlob.zipPath + preparedBlob.name, preparedBlob.blob, { binary: true });
                    });
                    collectionName = Evaluation.getKoEvaluation(evalType);
                    zipFileName = "(".concat(collectionName, ")(").concat(name, ")(") +
                        (dataType === 'template'
                            ? 'Template'
                            : dataType === 'uploaded'
                                ? '업로드파일'
                                : 'Template,업로드파일') +
                        ').zip';
                    return [4 /*yield*/, zip.generateAsync({ type: 'blob' })];
                case 4:
                    content = _a.sent();
                    (0, file_saver_1.saveAs)(content, zipFileName);
                    return [2 /*return*/];
            }
        });
    });
}
exports.downloadFilesInEvaluation = downloadFilesInEvaluation;
function downloadFile(type, evaluationName, controlId, fileName) {
    return __awaiter(this, void 0, void 0, function () {
        var collectionName, fileFullPath;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    collectionName = Evaluation.getKoEvaluation(type);
                    fileFullPath = "".concat(collectionName, "/").concat(evaluationName, "/").concat(controlId, "/").concat(fileName);
                    return [4 /*yield*/, (0, StorageManager_1.saveFromStorage)(fileFullPath, fileName)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.downloadFile = downloadFile;
//# sourceMappingURL=EvaluationDownloader.js.map